import ngAnnotate from '../ngAnnotate.macro';

interface LoginControllerScope extends ng.IScope {
  dataLoaded: boolean;
  user: {
    email: string;
    password: string;
  };
  login(): void;
}

function LoginController(
  $scope: LoginControllerScope,
  $http: ng.IHttpService,
  $rootScope: ng.IRootScopeService & {
    message: {
      type: string;
      data: string;
    };
  },
  $location: ng.ILocationService,
  $window: ng.IWindowService,
) {
  $scope.dataLoaded = false;

  let url = $location.absUrl().split('#')[1];
  if (url) {
    $rootScope.message = {
      type: 'warning',
      data: 'Please login to continue.',
    };
  }

  if (!url) {
    url = '/listing/list/brokerage/0';
  }

  $http.get<{ notAuthenticated: boolean }>('/user/current').then(({ data }) => {
    if (!data.notAuthenticated) {
      $window.location.replace(`/#${url}`);
    }
    $scope.dataLoaded = true;
  });

  $scope.login = () => {
    $scope.dataLoaded = false;

    // blackberry
    if (!$scope.user) {
      $scope.user = {
        email: $('#email').val(),
        password: $('#password').val(),
      };
    }

    $http
      .post<{ user: any; message: string }>('/login', $scope.user)
      .then(({ data }) => {
        if (data.user) {
          $window.location.replace(`/#${url}`);
        } else {
          $scope.dataLoaded = true;
          $rootScope.message = {
            type: 'warning',
            data: data.message,
          };
        }
      });
  };
}

ngAnnotate(LoginController);

export default LoginController;
